 
import api from './api';

const apiWithTags = api.enhanceEndpoints({
	addTagTypes: ['FlexLocations']
});

const flexProfessionalLocationsApi = apiWithTags.injectEndpoints({
	tagTypes: ['FlexLocations'],
	endpoints: (build) => ({
		flexLocations: build.query({
			query: ({ managementCompanyId }) => ({
				url: `/flex/management-companies/${managementCompanyId}/facilities`,
				headers: {
					'management-company-id': managementCompanyId
				}
			}),
			providesTags: ['FlexLocations']
		})
	})
});

export const { useFlexLocationsQuery, useUpdateLocationsStatusMutation } = flexProfessionalLocationsApi;
